import dayjs from "dayjs";
import { IFilter } from "./types";


const getInitialDataFilter = (): IFilter => {
    // const transactionTypeDefault = 'all';
    // const transactionStatusDefault = 'all';

    return {
        startDate: dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        endDate: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        establishment: '',
        ncm: '',
        barcode: '',
        num_doc: '',
        chv_nfe: '',
        codigo_plu: '',
        descricao_completa: '',
        icms_saida: '',
        descricao_secao: '',
        descricao_grupo: '',
        descricao_sub_grupo: '',
        codigo_ncm: '',
        codigo_pai_ncm: '',
        descricao_ncm: '',
        inicio_vigencia_ncm: '',
        fim_vigencia_ncm: '',
        page: 1,
        year: ''
    };
};
export default getInitialDataFilter;